export default "__VITE_ASSET__WEvp9KTz__"